import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SiteComponent } from './site/site.component';
import { ProductListComponent } from './dashboard/products/product-list/product-list.component';
import { ProductComponent } from './dashboard/products/product/product.component';
import { CategoryListComponent } from './dashboard/categorys/category-list/category-list.component';
import { CategorysComponent } from './dashboard/categorys/categorys.component';
import { CategoryComponent } from './dashboard/categorys/category/category.component';
import { ProductsComponent } from './dashboard/products/products.component';
import { StoresComponent } from './dashboard/stores/stores.component';
import { StoreComponent } from './dashboard/stores/store/store.component';
import { PrivacyComponent } from './dashboard/privacy/privacy.component';
import { SupportComponent } from './dashboard/support/support.component';
import { LocationsComponent } from './dashboard/locations/locations.component';
import { LocationComponent } from './dashboard/locations/location/location.component';
import { LocationListComponent } from './dashboard/locations/location-list/location-list.component';
import { UsersComponent } from './dashboard/users/users.component';
import { LogoutComponent } from './logout/logout.component';



const routes: Routes = [
  // {path:'',component:SiteComponent},
  {path:'',component:DashboardComponent},
  {path:'privacy',component:PrivacyComponent},
  {path:'support',component:SupportComponent},
  {path:'dashboard' ,component:DashboardComponent},
  {path:'dashboard/stores',component:StoresComponent},
  {path:'dashboard/store',component:StoreComponent},
  {path:'dashboard/products',component:ProductsComponent},
  {path:'dashboard/product',component:ProductComponent},
  {path:'dashboard/products-list',component:ProductListComponent},
  {path:'dashboard/categorys',component:CategorysComponent},
  {path:'dashboard/category-list',component:CategoryListComponent},
  {path:'dashboard/locations',component:LocationsComponent},
  {path:'dashboard/location',component:LocationComponent},
  {path:'dashboard/location-list',component:LocationListComponent},
  {path:'dashboard/users',component:UsersComponent},
  {path:'logout',component:LogoutComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
